export default {
  name: 'SignUpFooter',
  data() {
    return {
      footerTitle: '銀保服務站'
    }
  }
}